<template>
  <div>
    <h2>Legenda</h2>

    <p>
      Kvalitu koupacích vod pravidelně sledují krajské hygienické stanice (pouze
      vybraná místa) a provozovatelé koupališť. Na těchto stránkách naleznete
      přehled takto sledovaných koupacích vod v mapě. U každé koupací vody je
      uveden název koupacího místa, podrobnější údaje o lokalitě, datum
      posledního stanovení kvality vody, symbol kvality vody a popřípadě
      historické údaje o kvalitě vody. Na základě pětistupňové škály je tato
      kvalita definována následujícím způsobem:
    </p>

    <ul>
      <li>
        <img
          src="@/assets/vhodna.svg"
          width="30"
          height="30"
          alt="Voda vhodná ke koupání"
        />
        <p>
          <b>Voda vhodná ke koupání:</b>
          <br />
          nezávadná voda s nízkou pravděpodobností vzniku zdravotních problémů
          při vodní rekreaci s vyhovujícími smyslově postižitelnými vlastnostmi.
        </p>
      </li>
      <li>
        <img
          src="@/assets/nezavadna.svg"
          width="30"
          height="30"
          alt="Voda vhodná ke koupání s mírně zhoršenými vlastnostmi"
        />
        <p>
          <b>Voda vhodná ke koupání s mírně zhoršenými vlastnostmi:</b>

          <br />
          nezávadná voda s nízkou pravděpodobností vzniku zdravotních problémů
          při vodní rekreaci především se zhoršenými smyslově postižitelnými
          vlastnostmi, v případě možnosti je vhodné se osprchovat.
        </p>
      </li>
      <li>
        <img
          src="@/assets/zhorsena.svg"
          width="30"
          height="30"
          alt="Zhoršená jakost vody"
        />
        <p>
          <b>Zhoršená jakost vody:</b>
          <br />
          mírně zvýšená pravděpodobnost vzniku zdravotních problémů při vodní
          rekreaci, u některých vnímavých jedinců (těhotné ženy, děti, osoby
          alergií, osoby s oslabeným imunitním systémem) by se již mohly
          vyskytnout zdravotní obtíže, po koupání se doporučuje osprchovat.
        </p>
      </li>
      <li>
        <img
          src="@/assets/nevhodna.svg"
          width="30"
          height="30"
          alt="Voda nevhodná ke koupání"
        />
        <p>
          <b>Voda nevhodná ke koupání:</b>
          <br />
          voda neodpovídá hygienickým požadavkům a pro uživatele představuje
          zdravotní riziko, koupání a provozování vodních sportů nelze doporučit
          pro děti, těhotné ženy, osoby trpící alergií a osoby s oslabeným
          imunitním systémem.
        </p>
      </li>
      <li>
        <img
          src="@/assets/nebezpecna.svg"
          width="30"
          height="30"
          alt="Voda nebezpečná ke koupání - zákaz koupání"
        />
        <p>
          <b>Voda nebezpečná ke koupání - zákaz koupání:</b>
          <br />
          voda neodpovídá hygienickým požadavkům a hrozí akutní poškození
          zdraví, vyhlašuje se zákaz koupání.
        </p>
      </li>
      <li>
        <img
          src="@/assets/nemereno.svg"
          width="30"
          height="30"
          alt="Neměřeno nebo nedostatečná data pro stanovení kvality"
        />
        <p>
          <b>Neměřeno nebo nedostatečná data pro stanovení kvality.</b>
        </p>
      </li>
    </ul>

    <p>
      Zdrojem údajů je celostátní centrální registr kvality pitných a
      rekreačních vod PiVo a dále údaje na jednotlivých stránkách krajských
      hygienických stanic (KHS).
    </p>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$emit("caption", "Legenda");
  }
};
</script>

<style scoped>
ul {
  padding-left: 5px;
  /*padding: 0;*/
  list-style-type: none;
}
</style>
